module.exports = "<div class=\"table table-3\">\r\n  <h5 class=\"title-table\">Other Vaccines</h5>\r\n  <table datatable [dtOptions]=\"dtOptions\" id=\"vaccine_3\" class=\"display responsive nowrap\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/other-admin-vaccine-received/other-admin-vaccine-received.component.html
// module id = ../../../../../src/app/pages/admin-vaccine/other-admin-vaccine-received/other-admin-vaccine-received.component.html
// module chunks = main